/* eslint-disable react/destructuring-assignment */
import { ReactNode, createContext, useContext } from "react";
import { AppComposer } from "@tmsw/powerups.config.app.composer";
import type { GlobalContextsType } from "@tmsw/powerups.config.app.composer";

export type AppConfigContextType = {
  [key: string]: any;
}

export type AppConfigProviderProps = {
  config: {
    [key:string]: any
  };
  globalContexts?: GlobalContextsType
}

const AppConfigContext = createContext<AppConfigContextType | null>(null);

const useAppConfig = () => {
  const value = useContext(AppConfigContext);
  if (!value) throw new Error('Missing AppConfigProvider in the tree');
  return value;
};

export const AppConfigProvider = (props: AppConfigProviderProps & { children: ReactNode }) => {
  const { config, globalContexts } = props;
  console.log('AppConfig value=', config);

  return (
    <AppConfigContext.Provider value={config}>
      <AppComposer globalContexts={globalContexts}>
        {props.children}
      </AppComposer>
    </AppConfigContext.Provider>
  );
};

export {
  AppConfigContext,
  useAppConfig
};